import { render } from "./NeutralButton.vue?vue&type=template&id=6a1a1634&scoped=true"
import script from "./NeutralButton.vue?vue&type=script&lang=js"
export * from "./NeutralButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1a1634"]])

export default __exports__